import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadIxprnsrvcprinterListStatus: 'idle',
    loadIxprnsrvcprinterListError: undefined as any,
    loadIxprnsrvcprinterListLastArgs: undefined as any,
    loadIxprnsrvcprinterStatus: 'idle',
    loadIxprnsrvcprinterError: undefined as any,
    saveIxprnsrvcprinterStatus: 'idle',
    saveIxprnsrvcprinterError: undefined as any,
    deleteIxprnsrvcprinterStatus: 'idle',
    deleteIxprnsrvcprinterError: undefined as any,

    ixprnsrvcprinterList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadIxprnsrvcprinterList = createAsyncThunk('ixprnsrvcprinterSlice/loadIxprnsrvcprinterList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().ixprnsrvcprinterSlice.loadIxprnsrvcprinterListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/ixprnsrvcprinter/?action=gte&IXPRNSRVCID_FILTER=${parentModel.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadIxprnsrvcprinterListStatus } = getState().ixprnsrvcprinterSlice
        return loadIxprnsrvcprinterListStatus !== 'pending'
    }
})

export const loadIxprnsrvcprinter = createAsyncThunk('ixprnsrvcprinterSlice/loadIxprnsrvcprinter', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/ixprnsrvcprinter/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadIxprnsrvcprinterStatus } = getState().ixprnsrvcprinterSlice
        return loadIxprnsrvcprinterStatus !== 'pending'
    }
})

export const saveIxprnsrvcprinter = createAsyncThunk('ixprnsrvcprinterSlice/saveIxprnsrvcprinter', async ({ ixprnsrvcprinter }: any, { rejectWithValue }: any) => {
    let promises = []
    if (ixprnsrvcprinter?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/ixprnsrvcprinter/${ ixprnsrvcprinter?.HDR_ID }/`,
            prepareData(ixprnsrvcprinter),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/ixprnsrvcprinter/`,
            prepareData(ixprnsrvcprinter),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveIxprnsrvcprinterStatus } = getState().ixprnsrvcprinterSlice
        return saveIxprnsrvcprinterStatus !== 'pending'
    }
})

export const deleteIxprnsrvcprinter = createAsyncThunk('ixprnsrvcprinterSlice/deleteIxprnsrvcprinter', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/ixprnsrvcprinter/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteIxprnsrvcprinterStatus } = getState().ixprnsrvcprinterSlice
        return deleteIxprnsrvcprinterStatus !== 'pending'
    }
})

const IxprnsrvcprinterSlice = createSlice({
    name: 'ixprnsrvcprinterSlice',
    initialState,
    reducers: {
        resetloadIxprnsrvcprinterListError: (state) => {
            state.loadIxprnsrvcprinterListError = undefined
        },
        resetloadIxprnsrvcprinter: (state) => {
            state.formItem = undefined
            state.loadIxprnsrvcprinterError = undefined
        },
        resetloadIxprnsrvcprinterError: (state) => {
            state.loadIxprnsrvcprinterError = undefined
        },
        resetsaveIxprnsrvcprinter: (state) => {
            state.formItem = undefined
            state.saveIxprnsrvcprinterError = undefined
        },
        resetsaveIxprnsrvcprinterError: (state) => {
            state.saveIxprnsrvcprinterError = undefined
        },
        resetdeleteIxprnsrvcprinterError: (state) => {
            state.deleteIxprnsrvcprinterError = undefined
        },
        removeFromIxprnsrvcprinterListById: (state, action) => {
            state.ixprnsrvcprinterList = state.ixprnsrvcprinterList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromIxprnsrvcprinterListByIds: (state, action) => {
            state.ixprnsrvcprinterList = state.ixprnsrvcprinterList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.ixprnsrvcprinterList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadIxprnsrvcprinterListStatus = 'preloaded'
            state.loadIxprnsrvcprinterListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.ixprnsrvcprinterList = []
            state.loadIxprnsrvcprinterListStatus = 'idle'
            state.loadIxprnsrvcprinterListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadIxprnsrvcprinterList.pending, (state) => {
            state.loadIxprnsrvcprinterListStatus = 'pending'
            state.loadIxprnsrvcprinterListError = undefined
        })
        builder.addCase(loadIxprnsrvcprinterList.fulfilled, (state, action) => {
            state.loadIxprnsrvcprinterListStatus = 'idle'

            if (!action.payload) { return }

            state.loadIxprnsrvcprinterListLastArgs = action.payload.args

            {
                state.ixprnsrvcprinterList = action.payload.data

            }
        })
        builder.addCase(loadIxprnsrvcprinterList.rejected, (state, action) => {
            state.loadIxprnsrvcprinterListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadIxprnsrvcprinterListError = action.error.message
            } else {
                state.loadIxprnsrvcprinterListError = action.payload
            }
        })

        builder.addCase(loadIxprnsrvcprinter.pending, (state) => {
            state.loadIxprnsrvcprinterStatus = 'pending'
            state.loadIxprnsrvcprinterError = undefined
        })
        builder.addCase(loadIxprnsrvcprinter.fulfilled, (state, action) => {
            state.loadIxprnsrvcprinterStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.ixprnsrvcprinterList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.ixprnsrvcprinterList.push(newItem) }
                else { state.ixprnsrvcprinterList[i] = { ...state.ixprnsrvcprinterList[i], ...newItem } }
            }
        })
        builder.addCase(loadIxprnsrvcprinter.rejected, (state, action) => {
            state.loadIxprnsrvcprinterStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadIxprnsrvcprinterError = action.error.message
            } else {
                state.loadIxprnsrvcprinterError = action.payload
            }
        })

        builder.addCase(saveIxprnsrvcprinter.pending, (state) => {
            state.saveIxprnsrvcprinterStatus = 'pending'
            state.saveIxprnsrvcprinterError = undefined
        })
        builder.addCase(saveIxprnsrvcprinter.fulfilled, (state, action) => {
            state.saveIxprnsrvcprinterStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.ixprnsrvcprinterList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.ixprnsrvcprinterList.push(newItem) }
                else { state.ixprnsrvcprinterList[i] = { ...state.ixprnsrvcprinterList[i], ...newItem } }
            }
        })
        builder.addCase(saveIxprnsrvcprinter.rejected, (state, action) => {
            state.saveIxprnsrvcprinterStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveIxprnsrvcprinterError = action.error.message
            } else {
                state.saveIxprnsrvcprinterError = action.payload
            }
        })

        builder.addCase(deleteIxprnsrvcprinter.pending, (state) => {
            state.deleteIxprnsrvcprinterStatus = 'pending'
            state.deleteIxprnsrvcprinterError = undefined
        })
        builder.addCase(deleteIxprnsrvcprinter.fulfilled, (state, action) => {
            state.deleteIxprnsrvcprinterStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.ixprnsrvcprinterList = state.ixprnsrvcprinterList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.ixprnsrvcprinterList = state.ixprnsrvcprinterList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteIxprnsrvcprinter.rejected, (state, action) => {
            state.deleteIxprnsrvcprinterStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteIxprnsrvcprinterError = action.error.message
            } else {
                state.deleteIxprnsrvcprinterError = action.payload
            }
        })

    }
})

export const {
    resetloadIxprnsrvcprinterListError,
    resetloadIxprnsrvcprinter,
    resetloadIxprnsrvcprinterError,
    resetsaveIxprnsrvcprinter,
    resetsaveIxprnsrvcprinterError,
    resetdeleteIxprnsrvcprinterError,
    removeFromIxprnsrvcprinterListById,
    removeFromIxprnsrvcprinterListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = IxprnsrvcprinterSlice.actions
export default IxprnsrvcprinterSlice.reducer
